import React, { ReactNode } from "react";

import { createChangeEvent } from "../utils/form";

interface RadioProps {
  label: string;
  subLabel?: string;
  disabled?: boolean;
  name?: string;
  icon?: ReactNode;
  value?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
}

const radioStyle = `
  appearance-none h-5 w-5 bg-bg-components-base rounded-full border border-border-strong
  hover:bg-bg-components-hover 
  active:ring-focus active:ring-offset-1 active:border-border-interactive-base
  disabled:bg-bg-disabled disabled:border-border-disabled disabled:cursor-not-allowed disabled:ring-0 disabled:ring-offset-0
  checked:bg-icon-on-color checked:border-[5px] checked:border-border-interactive-base
  checked:hover:border-border-interactive-hover checked:disabled:border-bg-disabled checked:disabled:bg-icon-disabled
`;

const Radio = ({
  label,
  subLabel,
  disabled = false,
  icon,
  name,
  value,
  onChange,
}: RadioProps) => {
  const labelNode = (
    <div className="typography-medium-base">
      <div className="flex items-center space-x-1.5 mb-1">
        <span className={disabled ? "text-text-disabled" : "text-text-base"}>{label}</span>
        {icon && <span className={disabled ? "text-icon-disabled" : "text-icon-bg-base"}>{icon}</span>}
      </div>
      <span className={disabled ? "text-text-disabled" : "text-text-subtle"}>{subLabel}</span>
    </div>
  );
  return (
    <div className="flex space-x-3">
      <label htmlFor="custom-radio" className="relative inline-block space-x-3 h-6">
        <input
          disabled={disabled}
          id="custom-radio"
          type="radio"
          className={radioStyle}
          checked={value}
          onChange={(e) => {
            onChange(createChangeEvent(name, e.target.checked), e.target.checked);
          }}
        />
      </label>
      {labelNode}
    </div>
  );
};

export default Radio;
